<template>
  <div>
    <!-- <header class="w-full h-16 flex items-center z-50 bg-white border-b border-grey-light px-12">
      <Logo />
    </header> -->
  </div>
</template>

<script>
import Logo from './Logo';

export default {
  name: 'HeaderNonAuth',
  components: {
    Logo,
  },
};
</script>

<style lang="scss" module>
</style>
